export const fonts = {
  BentonSansBook: 'BentonSansBook',
  BentonSansMedium: 'BentonSansMedium',
  BentonSansRegular: 'BentonSansRegular',
  BentonSansWideMedium: 'BentonSansWideMedium',
  BentonSansWideBlack: 'BentonSansWideBlack',
};
